import React from "react";
import { useTranslate } from 'react-redux-multilingual'
import {Badge} from 'react-bootstrap';

const Raccourci = (props) => {
    const t =useTranslate()

    const handleClick = (title) => {
        if(title=='giftcard'){
            props.raccourciAction(title,false,false)
        }else if(title=='article'){
            props.raccourciAction(title,props.raccourciTypeId,false)
        }else{
            props.raccourciAction(title,false,props.raccourciTypeId)
        }
    } 

    // Edition du RPPSL
    const handleClickRpPsl = () => {
        props.setShowModalEdit(true)
        props.setArticleIdModal(props.raccourciTypeId)
        props.setRppsl(props.rppsl)
        let rppslId = props.rppsl.find(value=>value.article_id == props.raccourciTypeId)
        props.setRppslId(rppslId.id)
        props.setRpValue(rppslId.rp)
        props.setPslValue(rppslId.psl)
    } 

    // Création To
    const handleClickTo = () => {
        props.setShowModalAddTo(true)
        props.setArticleIdModal(props.raccourciTypeId)
        props.setArticleNameModal(props.title)
        props.setArticleSkuModal(props.sku)
    } 

    let raccourciTitle = props.title.toUpperCase()
    let raccourciColor = (props.raccourciType=='giftcard') ? "col-12 bg-primary rounded raccourciPos text-white" : (props.raccourciType=='article') ? "col-12 rounded raccourciPos text-white styleImgRaccourci" : "col-12 bg-info rounded raccourciPos text-white"

    let badgeColor = (props.stockArticle && +props.stockArticle > 0) ? 'success' : 'danger'
    let badgeColorDock = (props.stockDock && +props.stockDock > 0) ? 'success' : 'danger'
    let badgeColorRp = (props.stockArticle && props.rppsl && props.rppsl.length>0  && props.rppsl[0].rp<=props.stockArticle) ? 'success' : 'danger'
    let badgeColorPsl = 'white'
    let supStyle = (props.stockArticle && +props.stockArticle > 0) ? 'badgeStockRaccourci textDark' : 'badgeStockRaccourci'
    let supStyleDock = (props.stockDock && +props.stockDock > 0) ? 'badgeStockRaccourci textDark' : 'badgeStockRaccourci'
    let supStyleRp = (props.stockArticle && props.rppsl && props.rppsl.length>0  && props.rppsl[0].rp<=props.stockArticle) ? 'badgeStockRaccourci textDark' : 'badgeStockRaccourci'
    let supStylePsl = 'badgeStockRaccourci textDark'

    return (
        <div className={`${(window.screen.width>1200) ? "col-4" : "col-6"} position-relative`} style={{padding:"1px"}}>
            <div className={raccourciColor} onClick={() => handleClick(props.raccourciType)}>
                <div className="textAlign" style={{width:'100%', height:'100px'}}>
                    {(props.raccourciType=='article' && props.image!=null) ?
                        <img src={props.image.split(';')[0]} alt={props.title} className="imgRaccourci"/>
                    :
                        raccourciTitle
                    }
                </div>
            </div>
            {(props.raccourciType=='article' && props.image!=null) &&
                <>
                    <div className="itemTitle pointer text-center rounded-bottom" onClick={() => handleClick(props.raccourciType)}>{raccourciTitle}</div>
                </>
            }
            {(props.disabled) ?
                <div className="disabled rounded">
                </div>
            :
                false
            }
            {props.modulePos?.params?.raccourci_caisse?.params?.stock && 
                <>
                    {(props.raccourciType=='article' && props.stockArticle) &&
                        ((props.modulePos?.params?.raccourci_caisse?.params?.to) ?
                            <Badge pill bg={badgeColor} className={supStyle} onDoubleClick={()=>handleClickTo()}>
                                {props.stockArticle}
                            </Badge>
                        :
                            <Badge pill bg={badgeColor} className={supStyle}>
                                {props.stockArticle}
                            </Badge>
                        )
                    }
                    {(props.raccourciType=='article' && props.stockDock) &&
                        <Badge pill bg={badgeColorDock} className={supStyleDock} style={{top:'24%'}}>
                            {'d '+props.stockDock}
                        </Badge>
                    }
                    {console.log(props.rppsl)}
                    {(props.raccourciType=='article' && props.rppsl && props.rppsl.length>0) &&
                        ((props.modulePos?.params?.raccourci_caisse?.params?.rppsl) &&
                            <Badge pill bg={badgeColorRp} className={supStyleRp} style={{top:'44%'}} onDoubleClick={()=>handleClickRpPsl()}>
                                {'m '+props.rppsl[0].rp}
                            </Badge>     
                        )
                    }
                    {(props.raccourciType=='article' && props.rppsl && props.rppsl.length>0) &&
                        ((props.modulePos?.params?.raccourci_caisse?.params?.rppsl) &&
                            <Badge pill bg={badgeColorPsl} className={supStylePsl} style={{top:'65%'}} onDoubleClick={()=>handleClickRpPsl()}>
                                {'M '+props.rppsl[0].psl}
                            </Badge>
                        )
                    }
                </>
            }
        </div>
    )
}

export default Raccourci;  